export default __webpack_public_path__ + "static/media/8944.7b7971c1.svg";